import { TokenResponse, useGoogleLogin, hasGrantedAllScopesGoogle } from '@react-oauth/google';
import React from 'react';
import { BACKEND_URL } from './App';


interface LoginProps {
  setIsLogged: React.Dispatch<React.SetStateAction<boolean>>;
}


export async function fetchBackend(url: string, options: RequestInit) {
  return fetch(BACKEND_URL + url, {...options, credentials: 'include'});
}

export async function checkAuth() {
  const response = await fetchBackend("/check-auth", {method: 'GET'});
  return response.status === 200;
}


const Login: React.FC<LoginProps> = ({setIsLogged}) => {

  const logInSuccess = (tokenResponse: TokenResponse) => {
    const allowedAll = hasGrantedAllScopesGoogle(
      tokenResponse,
      "https://www.googleapis.com/auth/calendar.app.created");

    if (!allowedAll) {
      alert("Et antanut kaikkia tarvittavia oikeuksia");
      setIsLogged(false);
      return;
    }
    fetchBackend("/auth?token="+tokenResponse.access_token, {method: 'POST'})
    .then((res) => {
      if (res.status !== 200) {
        setIsLogged(false);
      } else {
        setIsLogged(true)
      }
    });
  }

  const loginAction = useGoogleLogin({
    onSuccess: codeResponse => logInSuccess(codeResponse),
    scope: 'https://www.googleapis.com/auth/calendar.app.created',
  });

  return (
    <div>
      <h1>Kirjaudu sisään</h1>
      <p>Käyttöoikeudet sovelluksen luomiin kalentereihin tarvitaan.
        Tämä ei anna oikeuksia henkilökohtaisiin kalentereihin</p>
    <button onClick={() => {
      loginAction();
    }
  }>Kirjaudu sisään Googlella 🚀</button>
  </div>
  )

};

export default Login;